import { useEffect, useState } from "react";

// Lets a page (the YourSpace/MySpace profile) tell the app shell to go full-bleed:
// drop the content max-width constraint and hide the right rail. The shell lives
// above the page in the tree, so we signal across it with a module flag + event
// (mirrors useSidebarCollapsed's pattern).
const EVENT_NAME = "fullBleedProfileChange";
let active = false;

export function setFullBleedProfile(next: boolean): void {
  if (active === next) return;
  active = next;
  if (typeof window !== "undefined") window.dispatchEvent(new Event(EVENT_NAME));
}

export function useFullBleedProfile(): boolean {
  const [value, setValue] = useState(active);
  useEffect(() => {
    const handler = () => setValue(active);
    handler(); // sync in case it changed before this listener mounted
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, []);
  return value;
}
